/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {defineMessages, useIntl} from 'react-intl';

const messages = defineMessages({
  emailLabel: {
    defaultMessage: 'Email address',
    id: 'use_reset_password_fields.label.email',
  },
  requiredEmail: {
    defaultMessage: 'Please enter a valid email address.',
    id: 'use_reset_password_fields.error.required_email',
  },
});

/**
 * @override
 * King Living reset password fields with "Email address" label (sentence case).
 */
export default function useResetPasswordFields({
  form: {
    control,
    formState: {errors},
  },
  prefix = '',
}) {
  const {formatMessage} = useIntl();

  const fields = {
    email: {
      name: `${prefix}email`,
      label: formatMessage(messages.emailLabel),
      defaultValue: '',
      type: 'email',
      autoComplete: 'email',
      rules: {
        required: formatMessage(messages.requiredEmail),
      },
      error: errors[`${prefix}email`],
      control,
    },
  };

  return fields;
}
